import { memo } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import { BiGridVertical } from 'react-icons/bi';

const ALERT_META = {
    OverBudget:                 { label: 'Over Budget',   color: 'danger'    },
    LowMargin:                  { label: 'Low Margin',    color: 'warning'   },
    NoRecentUpdate:             { label: 'No Updates',    color: 'secondary' },
    NearingDeadlineNotInvoiced: { label: 'Deadline Soon', color: 'warning'   },
};

export default memo(function AlertsList({ alerts }) {
    return (
        <div className="surface h-100 d-flex flex-column">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h3 className="fw-semibold fs-5 mb-0 drag-handle">Attention Needed</h3>
                <BiGridVertical className="drag-handle text-muted flex-shrink-0 d-none d-md-block" style={{ opacity: 0.4, fontSize: '1.1rem' }} />
            </div>
            {!alerts?.length ? (
                <p className="text-muted small mb-0">No alerts — everything looks good.</p>
            ) : (
                <div className="overflow-auto flex-grow-1">
                    {alerts.map((alert, i) => {
                        const meta = ALERT_META[alert.alertType] ?? { label: alert.alertType, color: 'secondary' };
                        return (
                            <div
                                key={`${alert.jobId}-${alert.alertType}-${i}`}
                                className="d-flex align-items-start gap-3 py-2 border-bottom"
                            >
                                <Badge color={meta.color} className="flex-shrink-0 mt-1">
                                    {meta.label}
                                </Badge>
                                <div className="flex-grow-1 overflow-hidden">
                                    <Link
                                        to={`/jobs/${alert.jobId}`}
                                        className="fw-semibold text-decoration-none d-block text-truncate"
                                    >
                                        {alert.jobNumber ? `${alert.jobNumber} — ` : ''}{alert.jobTitle}
                                    </Link>
                                    <span className="text-muted small">{alert.detail}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
});
